import { render, staticRenderFns } from "./MwanPaymentVerify.vue?vue&type=template&id=4e45e31a&scoped=true"
import script from "./MwanPaymentVerify.vue?vue&type=script&lang=js"
export * from "./MwanPaymentVerify.vue?vue&type=script&lang=js"
import style0 from "./MwanPaymentVerify.vue?vue&type=style&index=0&id=4e45e31a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e45e31a",
  null
  
)

export default component.exports